import React, { useRef } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import Icons from '../icons';
import {
  Root,
  HiddenInput,
  DropZone,
  CenterIconBox,
  FileMetaCol,
  FileNameRow,
  RemoveFileIcon,
  ActionsWrapper,
  UploadButton
} from './styled';
import { PaperWrapper } from '../../modules/common/styled';

export interface CsvUploadProps {
  file: File | null;
  onFileChange: (file: File | null) => void;
  onUpload: () => void;
  uploading: boolean;
  disabled?: boolean;
  accept?: string;
  resetKey?: number;
  showRemoveLink?: boolean;
  onRemoveFile?: () => void;
}

const CsvUpload: React.FC<CsvUploadProps> = ({
  file,
  onFileChange,
  onUpload,
  uploading,
  disabled,
  accept = '.csv',
  resetKey,
  showRemoveLink = true,
  onRemoveFile
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files && e.target.files[0];
    onFileChange(f || null);
  };

  const triggerBrowse = () => inputRef.current?.click();

  const content = (
    <Root>
      <HiddenInput
        key={resetKey}
        ref={inputRef}
        type='file'
        accept={accept}
        onChange={handleSelect}
      />
      <DropZone onClick={triggerBrowse}>
        <CenterIconBox>
          <Icons.Delete />
        </CenterIconBox>
        <FileMetaCol>
          <FileNameRow>
            <Typography variant='body2' sx={{ fontWeight: 500 }} noWrap>
              {file ? file.name : 'Select CSV file'}
            </Typography>
            {showRemoveLink && file && !uploading && (
              <RemoveFileIcon
                onClick={(e) => {
                  e.stopPropagation();
                  if (onRemoveFile) onRemoveFile();
                  else onFileChange(null);
                }}
                aria-label='Remove file'
              >
                <Icons.CloseCircleFilled />
              </RemoveFileIcon>
            )}
          </FileNameRow>
        </FileMetaCol>
      </DropZone>
      <ActionsWrapper>
        <UploadButton
          onClick={onUpload}
          disabled={!file || uploading || disabled}
        >
          {uploading ? (
            <CircularProgress size={20} color='inherit' />
          ) : (
            'Upload'
          )}
        </UploadButton>
      </ActionsWrapper>
    </Root>
  );

  return <PaperWrapper>{content}</PaperWrapper>;
};

export default CsvUpload;
